module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fi":{"sds-text-2":"Velan tila","sds-text-3":"Alkuperäinen velkoja"},"se":{"sds-text-2":"Skuld status","sds-text-3":"Ursprunglig fordringsägare"},"en":{"sds-text-2":"Debt status","sds-text-3":"Original creditor"}}')
  delete Component.options._Ctor
}
